import React from "react";

export const SkeletonBar = ({ width = "w-full", height = "h-4", className = "" }) => (
  <div className={`${height} ${width} bg-lightGray rounded-lg animate-pulse ${className}`} />
);

export const ActionButtonsSkeleton = () => (
  <>
    <SkeletonBar width="w-8" height="h-8" />
    <SkeletonBar width="w-8" height="h-8" />
  </>
);

export const CenteredSkeleton = ({ width }) => (
  <div className="md:flex md:justify-center">
    <SkeletonBar width={width} />
  </div>
);